/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Type_PlaceholderInputs */

const en_search_type_placeholder = /** @type {(inputs: Search_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search type...`)
};

const es_search_type_placeholder = /** @type {(inputs: Search_Type_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar tipo...`)
};

/**
* | output |
* | --- |
* | "Search type..." |
*
* @param {Search_Type_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_type_placeholder = /** @type {((inputs?: Search_Type_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Type_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_type_placeholder(inputs)
	return es_search_type_placeholder(inputs)
});